import React, { useEffect, useState, useRef } from "react";
import { connect } from "react-redux";
import Loader from "../Utilities/Loader";
import { toast } from "react-toastify";
import FileDownload from "js-file-download";

function ProjectDocuments({
  DetailedProjectData,
  projectDocumentsData,
  doFileUpload,
  getProjectDocuments,
  downloadFile,
  deleteFile,
}) {
  const [loading, setLoadig] = useState(false);
  const [buttonLoading, setButtonLoading] = useState(false);
  const [data, setData] = useState({
    document: "",
    description: "",
    documentName: "",
  });
  const [openOptionsId, setOpenOptionsId] = useState(null);
  const fileRef = useRef();

  const headerTitle = [
    {
      id: "1",
      label: "Files",
      classwidth: "2/3",
    },
    {
      id: "2",
      label: "Description",
      classwidth: "3/4",
    },
    {
      id: "3",
      label: "Actions",
      classwidth: "1/6",
    },
  ];

  const setValue = (field, value) => {
    const changedData = { ...data };
    changedData[field] = value;
    setData(changedData);
  };
  const resetField = () => {
    setData({ document: "", description: "", documentName: "" });
    fileRef.current.value = null;
  };
  const uploadFile = async () => {
    if (!data.document) {
      toast.error("no file choosen");
    } else {
      setButtonLoading(true);
      const formData = new FormData();
      formData.append("project_id", DetailedProjectData.project._id);
      formData.append("document", data.document, data.document.name);
      formData.append("description", data.description);
      formData.append("documentName", data.documentName);

      const responseData = await doFileUpload(formData);
      setButtonLoading(false);
      if (responseData.success) {
        toast.success(responseData.message);
        resetField();
        getDocuments();
      } else {
        toast.error(responseData.message);
      }
    }
  };
  const getDocuments = async () => {
    setLoadig(true);
    if (
      DetailedProjectData &&
      DetailedProjectData.project &&
      DetailedProjectData.project._id
    ) {
      await getProjectDocuments({
        projectId: DetailedProjectData?.project?._id,
      });
    }
    setLoadig(false);
  };
  const DownloaDocument = async (docId, filename) => {
    const response = await downloadFile({ docId });
    FileDownload(response, filename);
  };
  const ViewDocument = async (docId, filename) => {
    const response = await downloadFile({ docId });
    const fileURL = URL.createObjectURL(response);
    window.open(fileURL);
  };
  const DeleteDcoument = async (docId) => {
    if (window.confirm("Are you sure to delete this file?")) {
      const response = await deleteFile({ docId });
      if (response.success) {
        toast.success(response.message);
        getDocuments();
      } else {
        toast.error(response.message);
      }
    }
  };
  useEffect(() => {
    getDocuments();
  }, [DetailedProjectData]);

  return (
    <div>
      <h2 className="text-3xl text-black font-light my-6">Files</h2>
      <div className="flex items-start justify-start gap-10">
        <div className="max-w-full overflow-x-visible w-1/4">
          <div className="bg-theme-cream-2 border px-6 py-6 rounded-xl block md:flex md:flex-col gap-6 md:items-start mb-5">
            <p className="text-base text-start font-medium">Choose File</p>
            <div className="relative w-full">
              <input
                ref={fileRef}
                onChange={(e) => {
                  setValue("document", e.target.files[0]);
                }}
                type="file"
                name="document"
                className="absolute bg-theme-paper inset-0 w-full h-full opacity-0 cursor-pointer"
              />
              <div className="flex items-center border rounded-md h-10 w-full px-2 text-sm text-theme-fg-3 border-theme-cream-3">
                <span className="flex-1 truncate">
                  {data.document ? data.document.name : "No file chosen"}
                </span>
                <label className="bg-theme-avail-bg text-theme-avail-fg px-4 py-1 rounded-xl cursor-pointer text-xs">
                  Choose File
                </label>
              </div>
            </div>

            <input
              value={data.documentName}
              onChange={(e) => {
                setValue("documentName", e.target.value);
              }}
              type="text"
              name="documentName"
              placeholder="Document Name"
              className="mr-2 items-center mt-2 md:mt-0  focus:outline-none focus:border-theme-accent transition delay-150 duration-150 ease-linear text-sm border rounded-md h-10 py-1 px-4 w-full placeholder-theme-fg-3 text-theme-fg-3 font-normal border-theme-cream-3"
            />

            <textarea
              value={data.description}
              placeholder="Description"
              name="description"
              onChange={(e) => setValue("description", e.target.value)}
              className="mr-2 focus:outline-none focus:border-theme-accent transition delay-150 duration-150 ease-linear text-sm border rounded-md py-2 px-4 w-full placeholder-theme-fg-3 text-theme-fg-3 font-normal border-theme-cream-3 mt-2 md:mt-0 h-full md:h-10 resize-none"
            ></textarea>
          </div>
          <button
            type="button"
            className="mt-2 md:mt-0 font-title flex items-center bg-theme-ink hover:bg-theme-ink-2 text-white text-tiny font-medium transition duration-300 ease-out px-10 text-base rounded-md py-2"
            onClick={() => uploadFile()}
          >
            {!buttonLoading ? <p className="text-sm">Upload</p> : <Loader />}
          </button>
        </div>
        <div className="max-w-full ">
          <div className="bg-theme-cream-2 h-screen flex flex-col min-w-[768px] p-6 rounded-xl">
            <p className="text-base font-medium pb-6">Files</p>
            <div className="grid grid-cols-3 w-full gap-10">
              {!loading && projectDocumentsData.length ? (
                projectDocumentsData.map((file) => {
                  return (
                    <div
                      key={file._id}
                      className={`w-full h-full relative bg-theme-paper p-3 border rounded-md`}
                    >
                      <div
                        onClick={() =>
                          setOpenOptionsId(
                            openOptionsId === file._id ? null : file._id
                          )
                        }
                        className="flex items-center justify-between cursor-pointer"
                      >
                        <svg
                          width="18"
                          height="17"
                          viewBox="0 0 18 17"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M6.423 7.385H7.653C7.87167 7.385 8.05467 7.31134 8.202 7.164C8.34934 7.016 8.423 6.83334 8.423 6.616V5.385C8.423 5.167 8.34934 4.98434 8.202 4.837C8.05467 4.68967 7.872 4.616 7.654 4.616H6.039C5.93634 4.616 5.84634 4.65434 5.769 4.731C5.69234 4.80767 5.654 4.89734 5.654 5V9C5.654 9.10267 5.69234 9.19267 5.769 9.27C5.84634 9.346 5.93634 9.384 6.039 9.384C6.141 9.384 6.23067 9.34567 6.308 9.269C6.38467 9.19234 6.423 9.10267 6.423 9V7.385ZM6.423 6.615V5.385H7.653V6.615H6.423ZM11.385 9.385C11.603 9.385 11.7857 9.31133 11.933 9.164C12.0797 9.016 12.153 8.83334 12.153 8.616V5.385C12.153 5.167 12.0797 4.98434 11.933 4.837C11.7857 4.68967 11.603 4.616 11.385 4.616H9.846C9.74333 4.616 9.65367 4.65434 9.577 4.731C9.50033 4.80767 9.462 4.89734 9.462 5V9C9.462 9.10267 9.50033 9.19267 9.577 9.27C9.65367 9.346 9.74367 9.384 9.847 9.384L11.385 9.385ZM10.231 8.615V5.385H11.385V8.615H10.231ZM14.154 7.385H15.154C15.2567 7.385 15.3463 7.34634 15.423 7.269C15.5003 7.19234 15.539 7.10267 15.539 7C15.539 6.89734 15.5003 6.80734 15.423 6.73C15.3457 6.65267 15.2557 6.61467 15.153 6.616H14.153V5.385H15.153C15.2563 5.385 15.3463 5.34634 15.423 5.269C15.5003 5.19234 15.539 5.10267 15.539 5C15.539 4.89734 15.5003 4.80734 15.423 4.73C15.3463 4.654 15.2563 4.616 15.153 4.616H13.77C13.668 4.616 13.5783 4.65434 13.501 4.731C13.4243 4.80767 13.386 4.89734 13.386 5V9C13.386 9.10267 13.4243 9.19267 13.501 9.27C13.5783 9.34667 13.6683 9.385 13.771 9.385C13.8737 9.385 13.9633 9.34634 14.04 9.269C14.1167 9.19167 14.155 9.102 14.155 9L14.154 7.385ZM5.116 14C4.65534 14 4.271 13.846 3.963 13.538C3.655 13.23 3.50067 12.8457 3.5 12.385V1.615C3.5 1.155 3.65434 0.770669 3.963 0.462002C4.27167 0.153335 4.656 -0.000664511 5.116 2.15517e-06H15.885C16.345 2.15517e-06 16.7293 0.154002 17.038 0.462002C17.3467 0.770002 17.5007 1.15434 17.5 1.615V12.385C17.5 12.845 17.346 13.229 17.038 13.537C16.73 13.845 16.3453 13.9993 15.884 14H5.116ZM5.116 13H15.885C16.0383 13 16.1793 12.936 16.308 12.808C16.4367 12.68 16.5007 12.539 16.5 12.385V1.615C16.5 1.46167 16.436 1.32067 16.308 1.192C16.18 1.06334 16.0387 0.999335 15.884 1H5.116C4.962 1 4.82067 1.064 4.692 1.192C4.56334 1.32 4.49934 1.461 4.5 1.615V12.385C4.5 12.5383 4.564 12.6793 4.692 12.808C4.82 12.9367 4.961 13.0007 5.115 13M2.115 17C1.655 17 1.27067 16.846 0.962002 16.538C0.653335 16.23 0.499335 15.8457 0.500002 15.385V4.115C0.500002 3.97367 0.548002 3.855 0.644002 3.759C0.740002 3.663 0.859002 3.61534 1.001 3.616C1.143 3.61667 1.26167 3.66434 1.357 3.759C1.45234 3.85367 1.5 3.97267 1.5 4.116V15.385C1.5 15.5383 1.564 15.6793 1.692 15.808C1.82 15.9367 1.961 16.0007 2.115 16H13.385C13.5263 16 13.645 16.048 13.741 16.144C13.837 16.24 13.8847 16.359 13.884 16.501C13.8833 16.643 13.8357 16.7617 13.741 16.857C13.6463 16.9523 13.5273 17 13.384 17H2.115Z"
                            fill="#A75028"
                          />
                        </svg>
                        <svg
                          width="3"
                          height="13"
                          viewBox="0 0 3 13"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M1.5 1.75H1.50792M1.5 6.5H1.50792M1.5 11.25H1.50792"
                            stroke="#A2A2A2"
                            stroke-width="3"
                            stroke-linecap="round"
                          />
                        </svg>
                      </div>
                      {/* {openOptionsId === file._id && ( */}
                      <div className="">
                        <div
                          onClick={() => setOpenOptionsId(!openOptionsId)}
                          className={` ${
                            openOptionsId === file._id
                              ? "fixed inset-0 bg-black opacity-5 z-10 "
                              : "opacity-0"
                          }`}
                        ></div>
                        <div
                          className={`absolute bg-theme-paper z-40 -right-24 top-8 rounded-sm py-1 shadow-md transform transition-transform duration-200 ease-out ${
                            openOptionsId === file._id
                              ? "scale-100 opacity-100"
                              : "scale-95 opacity-0"
                          }`}
                        >
                          <ul className="flex flex-col items-start">
                            <li
                              className="flex items-center justify-start text-sm px-2 py-1 gap-3 border-b cursor-pointer w-full  hover:bg-theme-cream-2"
                              title="view document"
                              onClick={() =>
                                ViewDocument(
                                  file._id,
                                  file.documentOriginalName
                                )
                              }
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="19"
                                height="19"
                                viewBox="0 0 24 24"
                              >
                                <path
                                  d="M12.015 7c4.751 0 8.063 3.012 9.504 4.636-1.401 1.837-4.713 5.364-9.504 5.364-4.42 0-7.93-3.536-9.478-5.407 1.493-1.647 4.817-4.593 9.478-4.593zm0-2c-7.569 0-12.015 6.551-12.015 6.551s4.835 7.449 12.015 7.449c7.733 0 11.985-7.449 11.985-7.449s-4.291-6.551-11.985-6.551zm-.015 5c1.103 0 2 .897 2 2s-.897 2-2 2-2-.897-2-2 .897-2 2-2zm0-2c-2.209 0-4 1.792-4 4 0 2.209 1.791 4 4 4s4-1.791 4-4c0-2.208-1.791-4-4-4z"
                                  fill="#9d9fa2"
                                />
                              </svg>
                              Preview
                            </li>
                            <li
                              className="flex items-center text-sm justify-center gap-3 border-b  px-2 py-1 cursor-pointer  hover:bg-theme-cream-2"
                              title="download"
                              onClick={() =>
                                DownloaDocument(
                                  file._id,
                                  file.documentOriginalName
                                )
                              }
                            >
                              <svg
                                height="20"
                                width="20"
                                viewBox="0 0 120 120"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <title />
                                <g>
                                  <path
                                    d="M90,54a5.9966,5.9966,0,0,0-6,6V78H12V60A6,6,0,0,0,0,60V84a5.9966,5.9966,0,0,0,6,6H90a5.9966,5.9966,0,0,0,6-6V60A5.9966,5.9966,0,0,0,90,54Z"
                                    fill="#9d9fa2"
                                  />
                                  <path
                                    d="M43.7578,64.2422a5.9979,5.9979,0,0,0,8.4844,0l18-18a5.9994,5.9994,0,0,0-8.4844-8.4844L54,45.5156V12a6,6,0,0,0-12,0V45.5156l-7.7578-7.7578a5.9994,5.9994,0,0,0-8.4844,8.4844Z"
                                    fill="#9d9fa2"
                                  />
                                </g>
                              </svg>
                              Download
                            </li>
                            <li
                              className="flex w-full items-center justify-start gap-[18px] px-2 py-1 text-sm cursor-pointer hover:bg-theme-cream-2"
                              title="delete"
                              onClick={() => DeleteDcoument(file._id)}
                            >
                              <svg
                                width="14"
                                height="14"
                                viewBox="0 0 14 14"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  fillRule="evenodd"
                                  clipRule="evenodd"
                                  d="M11.0833 14H2.91666C2.27266 14 1.74999 13.4773 1.74999 12.8333V2.91667H1.16666V1.75H4.66666V0.875C4.66666 0.392583 5.05924 0 5.54166 0H8.45832C8.93957 0 9.33332 0.391417 9.33332 0.875V1.75H12.8333V2.91667H12.25V12.8333C12.25 13.4773 11.7273 14 11.0833 14ZM11.0833 2.91667H2.91666V12.5417C2.91666 12.7027 3.04732 12.8333 3.20832 12.8333H10.7917C10.9527 12.8333 11.0833 12.7027 11.0833 12.5417V2.91667ZM5.83332 5.25C5.83332 4.928 5.57199 4.66667 5.24999 4.66667C4.92799 4.66667 4.66666 4.928 4.66666 5.25V10.5C4.66666 10.822 4.92799 11.0833 5.24999 11.0833C5.57199 11.0833 5.83332 10.822 5.83332 10.5V5.25ZM9.33332 5.25C9.33332 4.928 9.07199 4.66667 8.74999 4.66667C8.42799 4.66667 8.16666 4.928 8.16666 5.25V10.5C8.16666 10.822 8.42799 11.0833 8.74999 11.0833C9.07199 11.0833 9.33332 10.822 9.33332 10.5V5.25ZM8.16666 1.16667H5.83332V1.75H8.16666V1.16667Z"
                                  fill="#F74051"
                                ></path>
                              </svg>
                              Delete
                            </li>
                          </ul>
                        </div>
                      </div>
                      {/* )} */}

                      <h3 className="font-sm font-title pt-2">
                        {file.documentName
                          ? file.documentName
                          : file.documentOriginalName}
                      </h3>
                    </div>
                    // <div
                    //   key={`docid_${file._id}`}
                    //   className="flex items-center justify-between py-3 hover:bg-primary-light transition duration-150 ease-out px-3 border-b"
                    // >
                    //   <div className="flex justify-start text-sm text-title basis-2/3 break-all ">
                    //     <svg
                    //       xmlns="http://www.w3.org/2000/svg"
                    //       width="20"
                    //       height="20"
                    //       viewBox="0 0 24 24"
                    //     >
                    //       <path
                    //         d="M22 13v-13h-20v24h8.409c4.857 0 3.335-8 3.335-8 3.009.745 8.256.419 8.256-3zm-4-7h-12v-1h12v1zm0 3h-12v-1h12v1zm0 3h-12v-1h12v1zm-2.091 6.223c2.047.478 4.805-.279 6.091-1.179-1.494 1.998-5.23 5.708-7.432 6.881 1.156-1.168 1.563-4.234 1.341-5.702z"
                    //         fill="#b5b3b3"
                    //       />
                    //     </svg>
                    //     <h3 className="font-medium font-title font-semibold ml-3">
                    //       {file.documentName
                    //         ? file.documentName
                    //         : file.documentOriginalName}
                    //     </h3>
                    //   </div>
                    //   <div className="flex justify-start text-sm text-title basis-3/4 break-all ">
                    //     {file.description}
                    //   </div>
                    //   <div className="flex justify-start basis-1/6 break-all pr-3 sm:pr-0">
                    //     <div className="mb-1 text-title text-sm font-normal flex items-center">
                    //       <div className="mr-3 items-center">
                    //         <button
                    //           title="view document"
                    //           onClick={() =>
                    //             ViewDocument(
                    //               file._id,
                    //               file.documentOriginalName
                    //             )
                    //           }
                    //         >
                    //           <svg
                    //             xmlns="http://www.w3.org/2000/svg"
                    //             width="24"
                    //             height="24"
                    //             viewBox="0 0 24 24"
                    //           >
                    //             <path
                    //               d="M12.015 7c4.751 0 8.063 3.012 9.504 4.636-1.401 1.837-4.713 5.364-9.504 5.364-4.42 0-7.93-3.536-9.478-5.407 1.493-1.647 4.817-4.593 9.478-4.593zm0-2c-7.569 0-12.015 6.551-12.015 6.551s4.835 7.449 12.015 7.449c7.733 0 11.985-7.449 11.985-7.449s-4.291-6.551-11.985-6.551zm-.015 5c1.103 0 2 .897 2 2s-.897 2-2 2-2-.897-2-2 .897-2 2-2zm0-2c-2.209 0-4 1.792-4 4 0 2.209 1.791 4 4 4s4-1.791 4-4c0-2.208-1.791-4-4-4z"
                    //               fill="#9d9fa2"
                    //             />
                    //           </svg>
                    //         </button>
                    //       </div>
                    //       <div className="mr-3 items-center">
                    //         <button
                    //           title="download"
                    //           onClick={() =>
                    //             DownloaDocument(
                    //               file._id,
                    //               file.documentOriginalName
                    //             )
                    //           }
                    //         >
                    //           <svg
                    //             height="20"
                    //             width="20"
                    //             viewBox="0 0 120 120"
                    //             xmlns="http://www.w3.org/2000/svg"
                    //           >
                    //             <title />
                    //             <g>
                    //               <path
                    //                 d="M90,54a5.9966,5.9966,0,0,0-6,6V78H12V60A6,6,0,0,0,0,60V84a5.9966,5.9966,0,0,0,6,6H90a5.9966,5.9966,0,0,0,6-6V60A5.9966,5.9966,0,0,0,90,54Z"
                    //                 fill="#9d9fa2"
                    //               />
                    //               <path
                    //                 d="M43.7578,64.2422a5.9979,5.9979,0,0,0,8.4844,0l18-18a5.9994,5.9994,0,0,0-8.4844-8.4844L54,45.5156V12a6,6,0,0,0-12,0V45.5156l-7.7578-7.7578a5.9994,5.9994,0,0,0-8.4844,8.4844Z"
                    //                 fill="#9d9fa2"
                    //               />
                    //             </g>
                    //           </svg>
                    //         </button>
                    //       </div>
                    //       <div className="mr-3 items-center">
                    //         <button
                    //           title="delete"
                    //           onClick={() => DeleteDcoument(file._id)}
                    //         >
                    //           <svg
                    //             width="14"
                    //             height="14"
                    //             viewBox="0 0 14 14"
                    //             fill="none"
                    //             xmlns="http://www.w3.org/2000/svg"
                    //           >
                    //             <path
                    //               fillRule="evenodd"
                    //               clipRule="evenodd"
                    //               d="M11.0833 14H2.91666C2.27266 14 1.74999 13.4773 1.74999 12.8333V2.91667H1.16666V1.75H4.66666V0.875C4.66666 0.392583 5.05924 0 5.54166 0H8.45832C8.93957 0 9.33332 0.391417 9.33332 0.875V1.75H12.8333V2.91667H12.25V12.8333C12.25 13.4773 11.7273 14 11.0833 14ZM11.0833 2.91667H2.91666V12.5417C2.91666 12.7027 3.04732 12.8333 3.20832 12.8333H10.7917C10.9527 12.8333 11.0833 12.7027 11.0833 12.5417V2.91667ZM5.83332 5.25C5.83332 4.928 5.57199 4.66667 5.24999 4.66667C4.92799 4.66667 4.66666 4.928 4.66666 5.25V10.5C4.66666 10.822 4.92799 11.0833 5.24999 11.0833C5.57199 11.0833 5.83332 10.822 5.83332 10.5V5.25ZM9.33332 5.25C9.33332 4.928 9.07199 4.66667 8.74999 4.66667C8.42799 4.66667 8.16666 4.928 8.16666 5.25V10.5C8.16666 10.822 8.42799 11.0833 8.74999 11.0833C9.07199 11.0833 9.33332 10.822 9.33332 10.5V5.25ZM8.16666 1.16667H5.83332V1.75H8.16666V1.16667Z"
                    //               fill="#F74051"
                    //             ></path>
                    //           </svg>
                    //         </button>
                    //       </div>
                    //     </div>
                    //   </div>
                    // </div>
                  );
                })
              ) : (
                <div className="flex justify-center items-center h-28">
                  <p className="text-sm text-title">{`${
                    loading ? "Loading..." : "No data"
                  }`}</p>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
const mapState = (state) => ({
  projectDocumentsData: state.projectDetails.files,
});
const mapDispatch = (dispatch) => ({
  doFileUpload: dispatch.projectDetails.doFileUpload,
  getProjectDocuments: dispatch.projectDetails.getProjectDocuments,
  downloadFile: dispatch.projectDetails.downloadFile,
  deleteFile: dispatch.projectDetails.deleteFile,
});

export default connect(mapState, mapDispatch)(ProjectDocuments);
